import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { VegetativeCyclePhenDate } from "./models";
import { ScholanderItemMap } from "../ferrari-widgets/models";

export default class SatellitesWidgetVuexModule extends AbacoVuexModule {
    @State() vegCyclesPhenDates!: VegetativeCyclePhenDate[];
    @State({ default: null}) curSatelliteIndexDate!: Date | null;
}
